export default __webpack_public_path__ + "static/media/SEBASTIAN PISTONE.9710d851.jpg";